// extracted by mini-css-extract-plugin
export default {"card":"ProjectsItem_card__8rwmc","technology":"ProjectsItem_technology__+POGd","links":"ProjectsItem_links__beT0R","link":"ProjectsItem_link__AhrPb"};